import {
  getGridName,
  getGridColumnsMetadata,
  getGridFilter,
  getGridRoute,
  getGridRouteForNewUI,
} from '../util/setting-mainstream-grids';

export function getName(selection) {
  return getGridName(selection, 0);
}

export const getColumnsMetadata = getGridColumnsMetadata;

export const getFilter = getGridFilter;

export function getRoute(selection) {
  return getGridRoute(selection, 'campaign');
}

export function getRouteForNewUI(options) {
  return getGridRouteForNewUI(options);
}
